import { render, staticRenderFns } from "./enderecoEntrega.vue?vue&type=template&id=157f4a32"
import script from "./enderecoEntrega.ts?vue&type=script&lang=js&external"
export * from "./enderecoEntrega.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('157f4a32')) {
      api.createRecord('157f4a32', component.options)
    } else {
      api.reload('157f4a32', component.options)
    }
    module.hot.accept("./enderecoEntrega.vue?vue&type=template&id=157f4a32", function () {
      api.rerender('157f4a32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/venda/enderecoEntrega.vue"
export default component.exports